import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=df08af76&scoped=true&"
import script from "./BannerSwiper.vue?vue&type=script&lang=js&"
export * from "./BannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=df08af76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df08af76",
  null
  
)

export default component.exports